import { IsNotEmpty, IsOptional, ValidateNested, IsBoolean } from "class-validator";
import { Type } from "class-transformer";

import { AddressDto } from "./address.dto";

import { IContact } from "./contact.interface";

export class ContactDto implements Omit<IContact, "_id"> {
  //

  // @IsOptional()
  // _id?: string;

  @IsNotEmpty()
  contact_type: string; //main contact, secretary, chairperson, ...

  @IsNotEmpty()
  first_name: string;

  @IsNotEmpty()
  last_name: string;

  @IsNotEmpty()
  phone: string;

  @IsNotEmpty()
  email: string;

  @IsOptional()
  user_id?: string;

  @IsOptional()
  @IsBoolean()
  is_trusted_secretary?: boolean;

  @IsOptional()
  @ValidateNested()
  @Type(() => AddressDto)
  address?: AddressDto;
}
